import React from 'react';
import { Translate } from 'react-redux-i18n';

const routes = [

];

export default routes;
